"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const redux_store_1 = __importDefault(require("companion-app-components/utils/redux-store"));
const core_1 = require("companion-app-components/utils/core");
const datasets_1 = require("companion-app-components/flux/datasets");
const auth_1 = require("companion-app-components/flux/auth");
const profile_1 = require("companion-app-components/flux/profile");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const accounts_1 = require("companion-app-components/flux/accounts");
const entitlements_1 = require("companion-app-components/flux/entitlements");
const GettingStartedWebFirst_1 = __importDefault(require("containers/SetupPage/GettingStartedWebFirst"));
const SetupPageCompanion_1 = __importDefault(require("./SetupPageCompanion"));
const SetupPageWebFirst_1 = __importDefault(require("./SetupPageWebFirst"));
const log = (0, core_1.getLogger)('containers/SetupPage');
const desktopClients = 'quicken_windows, quicken_mac';
const cloudClients = 'quicken_webapp';
const SetupPage = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_1.useNavigate)();
    const [newDatasetClientId, setNewDatasetClientId] = (0, react_1.useState)(null);
    const profile = (0, react_redux_1.useSelector)((state) => profile_1.profileSelectors.getProfile(state));
    const authSession = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getAuthSession(state));
    const datasetId = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getDatasetId(state));
    const datasetsById = (0, react_redux_1.useSelector)((state) => datasets_1.datasetsSelectors.getDatasetsById(state));
    const isLoadPendingDatasets = (0, react_redux_1.useSelector)((state) => datasets_1.datasetsSelectors.getLoadPending(state));
    const isLoadPendingFeatureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getLoadPending(state));
    const isLoadPending = isLoadPendingDatasets || isLoadPendingFeatureFlags;
    const webFirstEnabled = (0, react_redux_1.useSelector)((state) => entitlements_1.entitlementsSelectors.hasWebFirstEntitlements(state));
    const accountsById = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getAccountsById(state));
    const accountsLoadPending = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getLoadPending(state));
    const disableNewUserWebFirst = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state)).get('disableNewUserWebFirst');
    const entitledDatasetsLoadPending = (0, react_redux_1.useSelector)((state) => datasets_1.datasetsSelectors.getEntitledDatasetsLoadPending(state));
    const dispatchCreateDatasetAction = (dataset) => dispatch(datasets_1.datasetsActions.createDataset(dataset));
    const dispatchAuthSelectDatasetAction = (data) => dispatch(auth_1.authActions.authSelectDataset(data));
    const createNewDataset = (type) => {
        if (!type || desktopClients.indexOf(type) === -1) {
            log.log('Create Dataset Failed, you must pass a type of "quicken_windows" or "quicken_mac"');
        }
        let newDataset = redux_store_1.default && profile && datasets_1.datasetsSelectors.makeNewDataset(redux_store_1.default.getState(), profile);
        newDataset = newDataset && newDataset.set('platform', type === 'quicken_windows' ? 'QWIN_MWF' : 'QMAC_MWF');
        if (newDataset) {
            dispatchCreateDatasetAction(newDataset);
            setNewDatasetClientId(newDataset.clientId);
        }
    };
    // 1. Still loading, return nothing
    if (isLoadPending || entitledDatasetsLoadPending) {
        return null;
    }
    // 2. new dataset was created? then open it and navigate to getting started
    if (newDatasetClientId) {
        const newDataSet = datasetsById.find((dataset) => newDatasetClientId === dataset.clientId);
        if (newDataSet && newDataSet.id) {
            setNewDatasetClientId(undefined);
            dispatchAuthSelectDatasetAction(auth_1.authTypes.AuthSelectDatasetPayload({
                dataset: newDataSet,
                reload: false,
                location: '/getting-started-webfirst',
            }));
        }
        return null;
    }
    const datasetObject = datasetId && datasetsById && datasetsById.get(datasetId);
    const createdByClientId = (datasetObject && datasetObject.createdByClientId) || 'unknown';
    const hasDisableRemoteAccess = datasetObject && datasetObject.disableRemoteAccess;
    // This indicates the dataset has been created by Windows or Mac, we cannot ascertain if it is unused,
    // or just unsynced.  In this case they get the "companion" setup page to either instruct them how to
    // sync their desktop accounts, or they can start from scratch with a web-created (web first) dataset
    const useCompanion = (desktopClients.indexOf(createdByClientId) !== -1)
        || !webFirstEnabled || hasDisableRemoteAccess || disableNewUserWebFirst;
    if (!hasDisableRemoteAccess) {
        // 3. if dataset and it is created by cloud, then go to webfirst setup
        if (cloudClients.indexOf(createdByClientId) !== -1) {
            return <GettingStartedWebFirst_1.default />;
        }
        if (!isLoadPending && !useCompanion && datasetsById.size === 0 && webFirstEnabled) {
            navigate('platformSelector', { replace: true });
        }
        else if (!accountsLoadPending && (accountsById === null || accountsById === void 0 ? void 0 : accountsById.size) >= 1) {
            navigate('/', { replace: true });
        }
        else if (!accountsLoadPending && (accountsById === null || accountsById === void 0 ? void 0 : accountsById.size) === 0) {
            navigate('/empty-entity', { replace: true });
        }
    }
    return (<>
      {useCompanion && // dataset is from the desktop
            <SetupPageCompanion_1.default profile={profile} authSession={authSession} defaultTabIsWindows={createdByClientId === 'quicken_windows'}/>}
      {!useCompanion && // no dataset
            <SetupPageWebFirst_1.default profile={profile} authSession={authSession} defaultTabIsWindows={createdByClientId === 'quicken_windows'} onCreateDataset={createNewDataset}/>}
    </>);
};
exports.default = (0, react_1.memo)(SetupPage);
